import { createSelector } from '@ngrx/store';
import { selectInitState } from '../core.state';
import { InitState } from './init.models';

export const selectLivreaActiveFlag = createSelector(
	selectInitState,
	(state: InitState) => state.livreaActive
);
